import { render } from "./OpeningHours.vue?vue&type=template&id=be2cd166&ts=true"
import script from "./OpeningHours.vue?vue&type=script&lang=ts"
export * from "./OpeningHours.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__